module.exports = __webpack_public_path__ + "static/media/forms.535cc8e4.svg";